import AppointmentService from '../../../services/appointment/ServiceAppointment'
import * as moment from 'moment'
import deliveryPointService from '../../../services/delivery-point/DeliveryPointService'
import XLSX from 'xlsx'

export default {
    props: ["status", "enabledColumns"],

    data() {
        return {
            headers: [
                {
                    text: 'NÚMERO',
                    sortable: false
                },
                {
                    text: 'DOCUMENTO',
                    sortable: false
                },
                {
                    text: 'NOMBRE',
                    sortable: false
                },
                {
                    text: 'PUNTO DE ENTREGA',
                    sortable: false
                },
                {
                    text: 'FECHA',
                    sortable: false
                },                 
                {
                    text: 'HORA',
                    sortable: false
                },
                {
                    text: 'ESTADO CITA',
                    sortable: false
                },
                {
                    text: 'CONFIRMADA',
                    sortable: false
                }
            ],
            loading: false,
            appointments: [],
            totalAppointments: 0,
            pagination: {},
            rowsPerPageItems: [5, 10, 15, 20],
            statusItems: ['Agendada', 'Cancelada', 'Asistida', 'Vencido'],
            status: '',
            confirmedOptions: [
                {
                    option: 'yes',
                    text: 'Confirmada'
                },
                {
                    option: 'no',
                    text: 'No confirmada'
                }
            ],
            confirmed: '',
            minDate: moment().format('YYYY-MM-DD'),
            date: '',
            date2: '',
            dataPicker: false,
            identification: '',
            listDeliveryPoints: [],
            deliveryPoints: [],
            selected: []
        }
    },
    computed: {
        customHeaders() {
            return this.enabledColumns ? this.headers.filter(header => this.enabledColumns[header.id]) : this.headers
        }
    },
    watch: {
        pagination: {
            handler() {
                this.getAppointments()
            },
            deep: true
        }
    },
    async created () {
        await this.getDeliveryPoints()
    },
    methods: {

        toggleAll () {
            if (this.selected.length) this.selected = []
            else this.selected = this.appointments.slice()
        },

        showColumn(i) {
            return !this.enabledColumns || i >= this.enabledColumns.length || this.enabledColumns[i];
        },
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        async getAppointments() {
            this.loading = true;
            const { page, rowsPerPage } = this.pagination;
            if (this.date !== null & this.date !== undefined && this.date !== '') { 
                if (this.date2 === null || this.date2 === undefined || this.date2 === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha final'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') { 
                if (this.date === null || this.date === undefined || this.date === '') {
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: 'Debe seleccionar la fecha inicial'
                    })
                    this.loading = false;
                    return
                }
            }
            if (this.date === null || this.date === undefined) {
                this.date = ''
            }
            if (this.date2 === null || this.date2 === undefined) {
                this.date2 = ''
            }
            if (this.identification === null || this.identification === undefined) {
                this.identification = ''
            }
            if (this.status === null || this.status === undefined) {
                this.status = ''
            }
            if (this.confirmed === null || this.confirmed === undefined) {
                this.confirmed = ''
            }
            let response = await AppointmentService.searchAppointments(
                {
                    page: page - 1,
                    rowsPerPage,
                    initialDate: this.date,
                    finalDate: this.date2,
                    identification: this.identification,
                    confirmed: this.confirmed,
                    deliveryPoints: this.deliveryPoints,
                    status: this.status
                }
            )
            this.loading = false
            this.appointments = response.data[0]
            this.totalAppointments = response.data[1]

            this.appointments.forEach(appointment => {
                switch (appointment.status) {
                    case 'CANCELED':
                        appointment.status = 'CANCELADA'
                        break;
                    case 'SCHEDULED':
                        appointment.status = 'AGENDADA'
                        break;
                    case 'ATTENDED':
                        appointment.status = 'ASISTIDA'
                    default:
                        break;
                }
                switch (appointment.confirmed) {
                    case false:
                        appointment.confirmed = 'NO'
                        break;
                    case true:
                        appointment.confirmed = 'SI'
                        break;
                    default:
                        break;
                }
                this.$set(appointment, 'checked', false)
            });

        },
        changeInitialDate() {
            let initialDate = moment(this.date).format('YYYY-MM-DD')
            this.minDate = initialDate
            if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') {
                if (!moment(this.date2).isSameOrAfter(initialDate)) {
                    this.date2 = this.minDate
                }
            } else {
                this.date2 = this.minDate
            }
        },
        async getDeliveryPoints () {
            try {
              let response = await deliveryPointService.getAll()
              this.listDeliveryPoints = response.data
              this.deliveryPoints = []
            } catch (error) {
              this.$notify({
                group: "app",
                type: "error",
                text: 'Error'
              })
            }
        },
        async confirmAppointments () {
            try {
                const appointmentsToConfirm = this.selected.filter(a => a.status !== 'CANCELADA').map(a => a.id)
                await AppointmentService.confirm(
                    {
                        ids: appointmentsToConfirm
                    }
                )
                this.$notify({
                    group: 'app',
                    type: 'success',
                    text: 'Citas confirmadas / desconfirmadas con éxito'
                })
                this.getAppointments()
            } catch (error) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Ha ocurrido un error al confirmar las citas'
                })
            }
        },
        async attendAppointments () {
            try {
                const appointmentsToAttend = this.selected.filter(a => a.status !== 'CANCELADA').map(a => a.id)
                await AppointmentService.attendMultiple(
                    {
                        ids: appointmentsToAttend
                    }
                )
                this.$notify({
                    group: 'app',
                    type: 'success',
                    text: 'Estado de citas cambiado con éxito'
                })
                this.getAppointments()
            } catch (error) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Ha ocurrido un error al marcar las citas como asistidas'
                })
            }
        },
        async cancelAppointments () {
            try {
                const appointmentsToCancel = this.selected.filter(a => a.status !== 'CANCELADA').map(a => a.id)
                await AppointmentService.cancelMultiple(
                    {
                        ids: appointmentsToCancel
                    }
                )
                this.$notify({
                    group: 'app',
                    type: 'success',
                    text: 'Estado de citas cambiado con éxito'
                })
                this.getAppointments()
            } catch (error) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Ha ocurrido un error al marcar las citas como asistidas'
                })
            }
        },
        selectAll () {
            console.log(this.selected)
            // this.appointments.forEach(appointment => {
            //     appointment.checked = true
            // })
            // this.$forceUpdate()
        },
        filterKeyCount(e) {
            const key = e.key;
            if (/[0-9]/.test(key)) {} else {
                return e.preventDefault();
            }
        },
        async report () {
            try {
                if (this.date !== null & this.date !== undefined && this.date !== '') { 
                    if (this.date2 === null || this.date2 === undefined || this.date2 === '') {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: 'Debe seleccionar la fecha final'
                        })
                        this.loading = false;
                        return
                    }
                }
                if (this.date2 !== null & this.date2 !== undefined && this.date2 !== '') { 
                    if (this.date === null || this.date === undefined || this.date === '') {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: 'Debe seleccionar la fecha inicial'
                        })
                        this.loading = false;
                        return
                    }
                }
                if (this.date === null || this.date === undefined) {
                    this.date = ''
                }
                if (this.date2 === null || this.date2 === undefined) {
                    this.date2 = ''
                }
                if (this.identification === null || this.identification === undefined) {
                    this.identification = ''
                }
                if (this.status === null || this.status === undefined) {
                    this.status = ''
                }
                if (this.confirmed === null || this.confirmed === undefined) {
                    this.confirmed = ''
                }
                let response = await AppointmentService.report(
                    {
                        initialDate: this.date,
                        finalDate: this.date2,
                        identification: this.identification,
                        confirmed: this.confirmed,
                        deliveryPoints: this.deliveryPoints,
                        status: this.status
                    }
                )
                let columns = XLSX.utils.json_to_sheet(response.data)
                let wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, columns, 'Reporte')
                XLSX.writeFile(wb, 'reporte_citas.xlsx')
            } catch (error) {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'Ha ocurrido un error generando el reporte'
                })
            }
        }
    }
}